import { useEffect, useState } from 'react';

import './App.css';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import ProtectedRoute from './ ProtectedRoute';

import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Contracts from './pages/contracts/Contracts';
import ContractCard from './pages/contracts/ContractsDetail';
import ContractToPayList from './pages/payment/Contracts';
import liff from '@line/liff';
import PaymentDetail from './pages/payment/PaymentDetail';
import QR from './pages/QR';
import MenuLayout from './pages/MenuLayout';
import ContractToInformList from './pages/inform-payment/Contracts';
import UploadTransferSlip from './pages/inform-payment/UploadTransferSlip';

function App() {
  useEffect(() => {
    liff
      .init({
        liffId: import.meta.env.VITE_LIFF_ID,
      })
      .then(async () => {
        console.log('LIFF init succeeded');
      })
      .catch((e) => {
        alert(`พบข้อผิดพลาด: ${e.message}`);
      });
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/contracts"
              element={
                <ProtectedRoute>
                  <Contracts />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contracts/:id"
              element={
                <ProtectedRoute>
                  <ContractCard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payment"
              element={
                <ProtectedRoute>
                  <ContractToPayList />
                </ProtectedRoute>
              }
            />{' '}
            <Route
              path="/payment/:id"
              element={
                <ProtectedRoute>
                  <PaymentDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/qr/:id"
              element={
                <ProtectedRoute>
                  <QR />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inform-payment"
              element={
                <ProtectedRoute>
                  <ContractToInformList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inform-payment/:id"
              element={
                <ProtectedRoute>
                  <UploadTransferSlip />
                </ProtectedRoute>
              }
            />
            <Route
              path="/menu"
              element={
                <ProtectedRoute>
                  <div style={{ overflow: 'auto' }}>
                    <MenuLayout />
                  </div>
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
